<template>
    <div class="navbar" id="navbar">
        <div class="nav-btn" @click="toggleSideBar">
            <svg-icon icon-class="nav" />
            导航
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Navbar',
        computed: {
            ...mapState({
                sidebar: state => state.app.sidebar
            }),
            classObj() {
                return {
                    'sidebar-hide': !this.sidebar.opened,
                    'sidebar-show': this.sidebar.opened,
                    withoutAnimation: this.sidebar.withoutAnimation
                }
            }
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('app/toggleSideBar');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .navbar {
        height: 100px;
        background: rgba(255, 255, 255, 1) url('~@/assets/images/logo.png') no-repeat center center / auto 73%;

        .nav-btn {
            float: left;
            height: 80px;
            padding: 20px 0 0 40px;
            font-size: 28px;
            font-weight: 600;
            line-height: 60px;

            .svg-icon {
                float: left;
                width: 18px;
                height: 24px;
                margin: 18px 6px 0 0
            }
        }

    }
</style>
